export default __webpack_public_path__ + "static/emirates-cricket-3e4e9ca61661df643d49c1118a01965c.png";